import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getMethod, postMethod, putMethod, setAuthorizationToken } from "../../utils/apiServices";

export const getHomePageByType = createAsyncThunk("homepage/fetchHomePageByType", async (type) => {
  setAuthorizationToken(true);
  const response = await getMethod(`/api/admin/homepage/type/${type}`);
  return response;
});

const initialState = {
  loading: false,
  success: false,
  error: false,
  homepage: null,
};

const homepageSlice = createSlice({
  name: "homepage",
  initialState,
  // reducers: {
  //   isLoading: (state) => {
  //     state.loading = true;
  //     state.success = false;
  //     state.error = false;
  //   },
  //   isSuccess: (state, action) => {
  //     state.loading = false;
  //     state.success = true;
  //     state.error = false;
  //     state.homepage = action.payload;
  //   },
  //   isError: (state) => {
  //     state.loading = false;
  //     state.success = false;
  //     state.error = true;
  //   },
  // },

  extraReducers: (builder) => {
    builder.addCase(getHomePageByType.pending, (state) => {
      state.loading = true;
      state.success = false;
      state.error = false;
      state.homepage = null;
    });
    builder.addCase(getHomePageByType.fulfilled, (state, action) => {
      state.loading = false;
      state.success = true;
      state.homepage = action.payload.homePage;
      state.error = false;
    });
    builder.addCase(getHomePageByType.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload.message;
      state.success = false;
      state.homepage = null;
    });
  },
});

// export const { isLoading, isSuccess, isError } = homepageSlice.actions;

export default homepageSlice.reducer;

export const addHomepageType = (data, SuccessCB, ErrorCB) => async () => {
  const response = await postMethod(`/api/admin/homepage/create`, data);
  if (response?.success) SuccessCB(response);
  else ErrorCB(response || "An error occurred");
};

export const updateHomepageType = (type, data, SuccessCB, ErrorCB) => async () => {
  const response = await putMethod(`/api/admin/homepage/${type}`, data);
  if (response?.success) SuccessCB(response);
  else ErrorCB(response || "An error occurred");
};
